(function () {
    "use strict";

    var controllerId = "ordineCAdd";
    angular.module('app').controller(controllerId, ["$scope", "$rootScope", "$filter", "$uibModalInstance", "datacontext", "common", '$translate', ordineCAdd]);

    function ordineCAdd($scope, $rootScope, $filter, $uibModalInstance, datacontext, common, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');                
        
        $scope.docente = {};       
        $scope.docente.CodiceFiscale = "";
        $scope.docente.Id = 0;

        $scope.item = {};
        $scope.item.index = 1;        
        $scope.item.provincie = [];
        $scope.item.comuni = [];
        $scope.item.listino = [];        
        $scope.getComuni = getComuni;
        
        $scope.avanti = function () {
            if ($scope.docente.CodiceFiscale == null || $scope.docente.CodiceFiscale.trim() == '')
                return;

            datacontext.risorsa_getForBuy($scope.docente.CodiceFiscale).then(function (docente) {
                if (docente.Id != null && docente.Id > 0 && docente.SocietaId != null && docente.SocietaId > 0) {
                    datacontext.societa_get(docente.SocietaId).then(function (societa) {
                        if (societa.Id != null && societa.Id > 0) {
                            datacontext.risorsa_getDataFineLicenza(docente.Id).then(function (dataLicenza) {                                
                                $scope.docente = docente;
                                $scope.docente.Istituto = societa.RagioneSociale;
                                $scope.item.index = 2;
                                $scope.item.dataLicenza = dataLicenza;
                                getProvincie();
                                getComuni(docente.ProvinciaId);
                            });
                        }
                        else
                            logError($translate.instant('CFNonValido'));
                    });
                }
                else
                    logError($translate.instant('CFNonValido'));
            });
        }

        $scope.salvaRecapiti = function () {
            if (validaForm()) {
                return datacontext.risorsa_update($scope.docente).then(function (data) {
                    if (!data) {                        
                        $scope.item.index = 3;
                        getListino();
                        caricaRiepilogo();
                    }
                    else
                        logError($translate.instant('ImpossibileAggiornare'));
                });
            }
        }

        $scope.ok = function (isValid) {
            var item = {};            
            item.docenteId = $scope.docente.Id;
            item.docente = $scope.docente.Cognome + " " + $scope.docente.Nome;
            item.Credenziali = $scope.item.credenziali;
            $uibModalInstance.close(item);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getProvincie() {
            if ($scope.item.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                $scope.item.provincie = data;
            });            
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.item.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.item.comuni = data;
            });
        }        

        function validaForm() {
            if ($scope.docente.Indirizzo == null || $scope.docente.Indirizzo.trim().length == 0) {
                return false;
            }
            if ($scope.docente.ProvinciaId == null || $scope.docente.ProvinciaId == 0) {
                return false;
            }
            if ($scope.docente.ComuneId == null || $scope.docente.ComuneId == 0) {
                return false;
            }
            if ($scope.docente.Cap == null || $scope.docente.Cap.trim().length == 0) {
                return false;
            }
            if ($scope.docente.Email == null || $scope.docente.Email.trim().length == 0) {
                return false;
            }
            if ($scope.docente.CodiceFiscale == null || $scope.docente.CodiceFiscale.trim().length == 0) {
                return false;
            }
            if ($scope.docente.Cellulare == null || $scope.docente.Cellulare.trim().length == 0) {
                return false;
            }

            return true;
        }

        function caricaRiepilogo() {
            $scope.item.riepilogo = "";
            datacontext.ordine_calcolaCommerciale($scope.docente.Id).then(function (data) {
                $scope.item.riepilogo = $translate.instant('TotaleDovuto') + $filter("currency")(data.Totale) + $translate.instant('NuovaLicenza') + $filter("date")(data.DataFineLicenza, "dd/MM/yyyy") + ".";
            });
        }

        function getListino() {
            return datacontext.listino_getAll().then(function (items) {
                return $scope.item.listino = items;
            });
        }
    }
})();